import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66e76240"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode(" 获奖名单 | 2023年商业航天年度奖项重磅揭晓 "), /*#__PURE__*/_createElementVNode("span", {
  class: "time"
}, "2023-04-25"), /*#__PURE__*/_createElementVNode("span", {
  class: "source"
}, "来源：金塔发布")], -1));
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "sep"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 4月23日晚，“2023商业航天产业国际论坛·航天探索之夜”在安徽合肥顺利举办。 ", -1));
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 本次论坛围绕“商业航天新动能助力航天强国建设”主题，为推动商业航天产业蓬勃发展，鼓励商业航天企业良性有序竞争、树立行业模范，发挥新太空经济业态的巨大产业能量，为经济发展开拓更加广阔美好的发展前景，商业航天产业国际论坛现场首次公布了“2023商业航天年度奖项”获奖名单。 评选由商业航天领域专家，以及来自36氪、创业邦和亿欧的媒体专家组成专家评审团，给予专业支持；从融资额度、发射频次、行业知名度、招商引资力度、业务突破性等多维度进行严格筛选与综合评估，最终依次评选出商业航天年度人物、商业航天青年领袖、商业航天最具商业价值企业、商业航天最具品牌影响力企业、商业航天最佳新锐企业、商业航天最佳投资机构、商业航天供应链杰出供应商、商业航天最受欢迎落地园区、商业航天最具人气企业。 ", -1));
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 评选由商业航天领域专家，以及来自36氪、创业邦和亿欧的媒体专家组成专家评审团，给予专业支持；从融资额度、发射频次、行业知名度、招商引资力度、业务突破性等多维度进行严格筛选与综合评估，最终依次评选出商业航天年度人物、商业航天青年领袖、商业航天最具商业价值企业、商业航天最具品牌影响力企业、商业航天最佳新锐企业、商业航天最佳投资机构、商业航天供应链杰出供应商、商业航天最受欢迎落地园区、商业航天最具人气企业。 ", -1));
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 长光卫星技术股份有限公司宣明、北京星河动力航天科技股份有限公司刘百奇、蓝箭航天空间科技股份有限公司张昌武、北京天兵科技有限公司康永来、银河航天（北京）网络技术有限公司徐鸣、北京微纳星空科技有限公司高恩宇获商业航天年度人物奖。 ", -1));
const _hoisted_11 = ["src"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 遨天科技（北京）有限公司 王红霞、火箭派（太仓）航天科技有限公司程巍、上海航天空间技术有限公司邓成晨、湖南斯北图科技有限公司邢克飞、上海京济通信技术有限公司林叶嵩、湖南航升卫星科技有限公司项军华获商业航天青年领袖奖。 ", -1));
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 北京天兵科技有限公司、北京星河动力航天科技股份有限公司、蓝箭航天空间科技股份有限公司、长光卫星技术股份有限公司、银河航天（北京）网络技术有限公司、航天科工火箭技术有限公司、北京星际荣耀空间科技股份有限公司、珠海欧比特宇航科技股份有限公司获商业航天最具商业价值企业奖。 ", -1));
const _hoisted_15 = ["src"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 蓝箭航天空间科技股份有限公司、北京开运联合信息技术集团股份有限公司、上海埃依斯航天科技有限公司、长光卫星技术股份有限公司、航天科工火箭技术有限公司、中国长征火箭有限公司、氦星光联科技（深圳）有限公司、北京航天驭星科技有限公司获商业航天最具品牌影响力企业奖。 ", -1));
const _hoisted_17 = ["src"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 氦星光联科技（深圳）有限公司、北京极光星通科技有限公司、北京翔宇星辰科技有限公司、湖南鸿星科技有限公司、陕西天回航天技术有限公司、空天合一（北京）空间科技有限公司、陕西星辰航线科技有限公司、东方空间（山东）科技有限公司获商业航天最佳新锐企业奖。 ", -1));
const _hoisted_19 = ["src"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 方正和生投资、建银国际、元航资本、合肥创新投资、君度投资、鼎晖百孚、奇绩创坛、未来宇航获商业航天最佳投资机构奖。 ", -1));
const _hoisted_21 = ["src"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 西安华德航天科技有限公司、南京英田光学工程股份有限公司、湖南斯北图科技有限公司、上海京济通信技术有限公司、北京微分航宇科技有限公司、奥星雅博（天津）科技有限公司、遨天科技（北京）有限公司、重庆推重比动力科技有限公司获商业航天供应链杰出供应商奖。 ", -1));
const _hoisted_23 = ["src"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 酒泉市航天航空产业园（金塔县航天航空小镇）、文昌国际航天城、四川绵阳工业园区、上海大零号湾科技创新策源功能区、重庆两江新区航空航天产业园、海阳东方航天港产业园获商业航天最受欢迎落地园区奖。 ", -1));
const _hoisted_25 = ["src"];
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 西安艾可萨科技有限公司、上海埃依斯航天科技有限公司、北京开运联合信息技术集团股份有限公司、北京星际荣耀空间科技股份有限公司、遨天科技（北京）有限公司、北京国电高科科技有限公司、北京天兵科技有限公司、江苏深蓝航天有限公司获商业航天最具人气企业奖。 ", -1));
const _hoisted_27 = ["src"];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " “2023商业航天年度奖项”致力于商业航天发展，搭建了面向商业航天机构管理者的高端合作交流平台，期待未来涌现出更多优秀代表性商业航天企业和人才，为航天强国建设注入强大动能，实现商业航天高质量跨越式发展。 ", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mianze"
}, " 免责声明：本站文章版权归原作者及原出处所有 。如有侵权，请联系我们删除。 ", -1));
import img1 from '@/assets/news/news3-1.jpeg';
import img2 from '@/assets/news/news3-2.jpeg';
import img3 from '@/assets/news/news3-3.jpeg';
import img4 from '@/assets/news/news3-4.jpeg';
import img5 from '@/assets/news/news3-5.jpeg';
import img6 from '@/assets/news/news3-6.jpeg';
import img7 from '@/assets/news/news3-7.jpeg';
import img8 from '@/assets/news/news3-8.jpeg';
import img9 from '@/assets/news/news3-9.jpeg';
import img10 from '@/assets/news/news3-10.jpeg';
import img11 from '@/assets/news/news3-11.jpeg';
import img12 from '@/assets/news/news3-12.jpeg';
export default /*#__PURE__*/_defineComponent({
  __name: 'news1',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img1),
        alt: ""
      }, null, 8, _hoisted_5), _hoisted_6, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img2),
        alt: ""
      }, null, 8, _hoisted_7), _hoisted_8, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img3),
        alt: ""
      }, null, 8, _hoisted_9), _hoisted_10, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img4),
        alt: ""
      }, null, 8, _hoisted_11), _hoisted_12, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img5),
        alt: ""
      }, null, 8, _hoisted_13), _hoisted_14, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img6),
        alt: ""
      }, null, 8, _hoisted_15), _hoisted_16, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img7),
        alt: ""
      }, null, 8, _hoisted_17), _hoisted_18, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img8),
        alt: ""
      }, null, 8, _hoisted_19), _hoisted_20, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img9),
        alt: ""
      }, null, 8, _hoisted_21), _hoisted_22, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img10),
        alt: ""
      }, null, 8, _hoisted_23), _hoisted_24, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img11),
        alt: ""
      }, null, 8, _hoisted_25), _hoisted_26, _createElementVNode("img", {
        style: {
          "width": "660px"
        },
        src: _unref(img12),
        alt: ""
      }, null, 8, _hoisted_27), _hoisted_28, _hoisted_29])], 64);
    };
  }
});